import {useMutation} from 'react-query';
import CustomerPortalAPI, {DeepThoughtError, Document} from '../../../APIs/CustomerPortalAPI';

type DocumentMutationInput = Partial<Pick<Document, 'id' | 'name' | 'filename' | 's3key'>>;

async function createDocument(...args: Parameters<typeof CustomerPortalAPI.createDocument>) {
    const resp = await CustomerPortalAPI.createDocument(...args);
    if (resp?.errors || !resp?.data?.createDocument) throw new DeepThoughtError(resp?.errors);
    return resp?.data.createDocument;
}

async function updateDocument(...args: Parameters<typeof CustomerPortalAPI.updateDocument>) {
    const resp = await CustomerPortalAPI.updateDocument(...args);
    if (resp?.errors || !resp?.data?.updateDocument) throw new DeepThoughtError(resp?.errors);
    return resp?.data.updateDocument;
}

// eslint-disable-next-line import/prefer-default-export
export function useDocumentMutation() {
    return useMutation<Document, Error, DocumentMutationInput, {previousDocuments: Document[]}>(async (input) => {
        /* prettier-ignore */
        const mutate = input.id
                ? updateDocument
                : createDocument
        return mutate(input);
    });
}
